import * as React from "react";
import { useStudentFilterContext } from "../../components/features/NewStudentFilter/useStudentFilterContext";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsPage from "../../hocs/enhanceSectionsPage";
import { useFetchSectionKartes } from "../../hooks/http/useFetchSectionKartes";
import { useQueryError } from "../../hooks/http/useQueryError";
import { useOnMainScrollAreaScroll } from "../../hooks/useMainScrollAreaScroll";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsKartes from "./SectionsKartes";

interface Props extends OutletContextProps {
  section: SectionInterface;
}

const SectionsKartesPage = ({ section, setActiveMenu }: Props) => {
  const { currentFilter } = useStudentFilterContext();

  React.useEffect(() => {
    setActiveMenu("karte");
  }, []);

  const { kartes, isPending, isFetchingNextPage, loadMore, error } =
    useFetchSectionKartes({
      sectionId: section.id,
      query: currentFilter,
    });
  useQueryError(error);

  useOnMainScrollAreaScroll(() => {
    loadMore();
  }, [loadMore]);

  return (
    <SectionsKartes
      section={section}
      kartes={kartes ?? []}
      isLoading={isPending || isFetchingNextPage}
    />
  );
};

export default enhanceSectionsPage(SectionsKartesPage, {
  title: "カルテ",
});
